import { createRouter, createWebHistory } from 'vue-router';

/* One-page site: the landing, the privacy policy and a 404. The Aeroland template's
   demo routes are gone (see git history); its view files remain in src/views but are
   not imported, so they are not built. */
const routes = [
    { path: '/', name: 'Home', component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue') },
    { path: '/privacy-policy', name: 'Privacy', component: () => import(/* webpackChunkName: "Privacy" */ '../views/Privacy.vue') },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue') },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { el: to.hash, behavior: 'smooth' };
        return savedPosition || { top: 0 };
    },
});

export default router;
